/**
 * Compose Message Dialog Types
 * Shared type definitions for compose components
 */

export interface Expert {
  id: string;
  display_name: string;
  name: string;
  lastname: string | null;
  business: string | null;
  city: string | null;
  state_province: string | null;
  country: string | null;
  location_id: number | null;
  image: string | null;
  membership_tier?: string | null;
  profile_listed: boolean | null;
  about: string | null;
  vanity_url: string | null;
  users_users_practice_areas?: Array<{
    users_practice_areas: {
      practice_area: string | null;
    } | null;
  }> | null;
  // Match data from intelligent matching
  matchScore?: number;
  matchReason?: string;
}

export interface InitialRecipient {
  id: string;
  name: string;
  image?: string | null;
}

export interface ComposeFormData {
  subject: string;
  message: string;
  service_type: string;
  location: string;
  budget_range: string;
  timeline: string;
}

export interface ComposeMessageDialogProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  onSuccess?: () => void;
  initialRecipients?: InitialRecipient[];
  initialSubject?: string;
  initialMessage?: string;
  initialServiceType?: string;
  initialLocation?: string;
  lockedRecipients?: boolean;
  context?: string;
  hideTrigger?: boolean;
}

export interface UserData {
  email: string;
  display_name: string | null;
  name: string | null;
  location_id: number | null;
  state_province: string | null;
  city: string | null;
}

/**
 * Helper function to get expert display name with fallbacks
 */
export const getExpertDisplayName = (expert: Expert): string => {
  // 1st: display_name
  if (expert.display_name && expert.display_name.trim()) {
    return expert.display_name;
  }
  
  // 2nd: name + lastname
  const fullName = [expert.name, expert.lastname].filter(Boolean).join(' ').trim();
  if (fullName) {
    return fullName;
  }
  
  // 3rd: business
  if (expert.business && expert.business.trim()) {
    return expert.business;
  }
  
  // Fallback - returns empty string for translation lookup by caller
  return '';
};
